import React from 'react'
import { Image, ImageBase } from '../../../../utils/image'
import { pageheaderHeroSrc, pageheaderHeroSrcSet } from '../../../../utils/imageSizes'
import { SpaarneCentrumType } from '../../../../utils/spaarneIcons'
import { GenericPageHeader, HeroPageHeader } from '../../../sharedLayout/pageheader'
import { PageHeaderNavLayout } from '../../../sharedLayout/pageheaderUtils'
import { ContactItem } from '../../cmsPageState'

type DepartmentPageHeaderProps = {
  title: string
  intro: string
  link?: { url: string; title: string }
  image?: ImageBase
  contactItems: ContactItem[]
  appointmentUrl?: string
  waitingTimesUrl?: string
  breadcrumbs: { url: string; title: string }[]
  blocks: { title: string; index: number }[]
  centrum?: { title: SpaarneCentrumType; url: string }
  menuOpened?: boolean
  toggleMenu?: () => void
}

export const DepartmentPageHeader = (props: DepartmentPageHeaderProps) =>
  props.centrum ? (
    <HeroPageHeader
      kind="centra-department"
      title={props.title}
      intro={props.intro}
      link={props.link}
      breadcrumbs={props.breadcrumbs}
      visual={
        <div className="pageheader__visual">
          <div className='pageheader__visual--container'>
            <div className='fit-object'>
              {props.image ? (
                <Image
                src={pageheaderHeroSrc}
                srcset={pageheaderHeroSrcSet}
                sizes="(min-width: 81.5rem) 1224px, 100vw"
                lazyload={false}
                classNames={{ image: 'pageheader__image', picture: 'pageheader__wrapper' }}
                alt={props.image.alt}
                urls={props.image.urls}
                width="1220"
                height="615"
              />
            ) : undefined }
            </div>
          </div>
        </div>
      }
      topTasks={
        <PageHeaderNavLayout
          kind="centrum-department"
          appointmentUrl={props.appointmentUrl}
          centrumLogo={props.centrum}
          contactItems={props.contactItems}
          waitingTimesUrl={props.waitingTimesUrl}
          navBottom={{ kind: 'anchors', items: props.blocks }}
        />
      }
    />
  ) : (
    <GenericPageHeader
      kind="departmentDetail"
      breadcrumbs={props.breadcrumbs}
      title={props.title || ''}
      intro={props.intro}
      link={props.link}
      image={props.image}
      extraJSXBelowText={
        <PageHeaderNavLayout
          kind='department'
          appointmentUrl={props.appointmentUrl}
          centrumLogo={props.centrum}
          contactItems={props.contactItems}
          waitingTimesUrl={props.waitingTimesUrl}
          navBottom={{ kind: 'anchors', items: props.blocks }}
          toggleMenu={props.toggleMenu}
          menuOpened={props.menuOpened ?? false}
        />
      }
    />
  )
